<template>
  <el-col :span="isMobile ? 24 : 12" class="calc-res-item">
    <h2 class="tt-up p-0-20">{{ config.title }} ({{ count }})</h2>
    <el-scrollbar class="calc-card">
      <div v-if="!items.length" class="p-0-20">Нет данных</div>
      <results-item
        v-for="(item, i) in items"
        :key="i"
        :item="item"
        :config="config"
      />
    </el-scrollbar>
    <el-row class="ta-r prb-20">
      <el-link
        v-if="items.length"
        type="primary"
        @click="$emit('show', items, config)"
      >
        На карте
      </el-link>
    </el-row>
  </el-col>
</template>

<script>
import ResultsItem from './ResultsItem'

export default {
  name: 'ResultsItems',
  components: { ResultsItem },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    config: {
      type: Object,
      default: () => {},
    },
    count: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style lang="sass">
.calc-res-item
  .calc-card
    margin: 30px 0
    .el-scrollbar__wrap
      overflow-x: auto
      max-height: 500px
  .prb-20
    padding-right: 20px
    padding-bottom: 20px
.calc-mob .calc-res-item
  .p-0-20
    padding: 0 20px
</style>
